import { createApp } from 'vue';
import { createPahoMqttPlugin } from 'vue-paho-mqtt';
import Vue3Toastify, { toast } from 'vue3-toastify';
// eslint-disable-next-line import/no-extraneous-dependencies
import VueSidebarMenu from 'vue-sidebar-menu';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

const version = '1.0.5';

const cors = require('cors');

const app = createApp(App);
app.use(cors);
app.use(i18n);
app.use(store);
app.use(router);
app.use(Vue3Toastify, {
  autoClose: 3000,
  position: toast.POSITION.TOP_RIGHT,
});
app.use(VueSidebarMenu);
app.use(
  createPahoMqttPlugin({
    PluginOptions: {
      autoConnect: false,
      showNotifications: false,
    },
    MqttOptions: {
      host: 'broker.kingdragon.com.tw',
      port: 8083,
      username: 'cus_dev',
      password: 'CU84521588',
      useSSL: true,
    },
  }),
);
app.provide('version', version);
app.provide('apiBaseUrl', 'https://api2.kingdragon.com.tw');
app.mount('#app');
